var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertSpeedTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "#FF0000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1401 0.354004H7.22707L0.183594 7.39748V17.3105L7.22707 24.354H17.1401L24.1836 17.3105V7.39748L17.1401 0.354004Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4027 11.5278H22.4896C22.2722 9.44089 21.4462 7.52784 20.1853 6.0061L18.707 7.48436C19.6201 8.65828 20.2288 10.0061 20.4027 11.5278Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.27 6.0497L18.7483 4.57144C17.2266 3.31057 15.3135 2.48448 13.2266 2.26709V4.35405C14.7048 4.52796 16.0961 5.13666 17.27 6.0497Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1389 4.35405V2.26709C9.05197 2.48448 7.13893 3.31057 5.61719 4.57144L7.09545 6.0497C8.22588 5.13666 9.61719 4.52796 11.1389 4.35405Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14029 6.0061C2.87942 7.57132 2.05333 9.48437 1.83594 11.5278H3.92289C4.09681 10.0061 4.7055 8.6148 5.61855 7.48436L4.14029 6.0061Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6151 7.68652L13.2911 16.2381H11.0999L10.776 7.68652H13.6151ZM10.6992 18.8897C10.6992 18.5089 10.8356 18.1877 11.1085 17.9263C11.3813 17.6648 11.7422 17.5341 12.1913 17.5341C12.6346 17.5341 12.9899 17.6648 13.257 17.9263C13.5299 18.1877 13.6663 18.5089 13.6663 18.8897C13.6663 19.2762 13.5299 19.6002 13.257 19.8617C12.9899 20.1175 12.6346 20.2454 12.1913 20.2454C11.7422 20.2454 11.3813 20.1175 11.1085 19.8617C10.8356 19.6002 10.6992 19.2762 10.6992 18.8897Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSpeedTravel);
export default __webpack_public_path__ + "static/media/alert-speed-travel.a2aec4f537469cef2af406565c460480.svg";
export { ForwardRef as ReactComponent };